import { ListingMatch } from '@deltek/specification-client/core/Models/listingSearch'

export type SelectionType = 'BOD' | 'Product'
export type PartnershipType = 'BIM Resources' | 'Sustainability Resources'
export type DisplayTextFormatType =
    | 'ManufacturerAndProduct'
    | 'Manufacturer'
    | 'None'

export type ProductListingDialogFacet =
    | 'Categories'
    | 'SectionNames'
    | 'ListingLevels'
    | 'ProductType'
    | 'FirmName'
    | 'Sustainability Resources'
    | 'BIM Resources'
    | 'partnerships'

export enum ListingDisplayTextFormat {
    ManufacturerAndProduct = 'MANUFACTURERANDPRODUCT',
    Manufacturer = 'MANUFACTURER',
    None = 'NONE',
}

export enum PtpOptionsToInclude {
    MasterSpecAndManufacturerOptions = 'MASTERSPECANDMANUFACTUREROPTIONS',
    MasterSpecOptions = 'MASTERSPECOPTIONS',
    NoOptions = 'NOOPTIONS',
}

export interface ProductListingSelected extends Partial<ListingMatch> {
    selectionType: SelectionType
    isBOD: boolean
    elementId: string
    hasSupportedManufacturersOptions: boolean
    productFamilyId?: string
    projectNuggetId?: string
}

export enum productOptions {
    ADDED_TO_PROJECT = 'Added to Project',
    FLAGGED_FOR_REVIEW = 'Flagged for Review',
}
